import { Account, Address } from '@Types/account';
import { Country } from '@Types/config/Country';

export class AddressUtils {
  public static mergeCountryLists(...lists: Country[][]): Country[] {
    const mergedList: Country[] = [];
    for (const list of lists) {
      for (const country of list) {
        if (!mergedList.some((current) => current.isoCode === country.isoCode)) {
          mergedList.push(country);
        }
      }
    }
    return AddressUtils.sortCountryList(mergedList);
  }

  public static intersectCountryLists(...lists: Country[][]): Country[] {
    return lists.reduce((intersected, list, currentIndex) => {
      if (currentIndex === 0) {
        return list;
      }

      return intersected.length === 0
        ? intersected
        : intersected.filter((entry) => list.some((country) => country.isoCode === entry.isoCode));
    }, []);
  }

  public static sortCountryList(countries: Country[]): Country[] {
    countries.sort((current, next) => {
      const sortOrderCurrent = current.sortOrder ?? 0;
      const sortOrderNext = next.sortOrder ?? 0;

      if (sortOrderCurrent !== sortOrderNext) {
        return sortOrderCurrent === 0 || (sortOrderNext !== 0 && sortOrderCurrent > sortOrderNext) ? 1 : -1;
      }
      return current.countryName === next.countryName ? 0 : current.countryName < next.countryName ? -1 : 1;
    });
    return countries;
  }

  public static hasDefaultAddress(type: string, account: Account): boolean {
    if (!account.addresses?.length) {
      return false;
    }

    return account.addresses.some((address) =>
      type !== 'shipping' ? address.isDefaultBillingAddress : address.isDefaultShippingAddress,
    );
  }

  public static getSwitchTypes(
    address: Address,
    billingCountries?: Country[],
    shippingCountries?: Country[],
  ): string[] {
    const switchTypes: string[] = [];
    if (AddressUtils.isCountryValid(address, billingCountries)) {
      switchTypes.push('billing');
    }

    if (AddressUtils.isCountryValid(address, shippingCountries)) {
      switchTypes.push('delivery');
    }

    return switchTypes;
  }

  public static isSameSwitchType(currentType: string[], newTypes: string[]): boolean {
    return currentType.length === newTypes.length && currentType.every((type) => newTypes.includes(type));
  }

  public static isCountryValid(address: Address, countries?: Country[]): boolean {
    return !countries?.length || countries.some((country) => country.isoCode === address.country);
  }
}
